module.exports = "<div class=confirm-box> <div class=text> <p></p> </div> <div class=button> <button class=yes>确定</button> <button class=no>取消</button> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/util/confirm/confirm.html
// module id = 1888
// module chunks = 50